<!-- 谈话记录 -->
<template>
  <div class="Crisis_major_consult">
    <el-form style="padding: 20px;" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="综合查询">
        <el-input v-model="formInline.UserID" placeholder="学号/姓名/身份证号"></el-input>
      </el-form-item>
      <el-form-item label="访谈状态">
        <el-select v-model="formInline.Status" placeholder="请选择访谈状态">
          <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="onSubmit2">重置</el-button>
        <el-button type="primary" @click="derivefun()">导出</el-button>
      </el-form-item>
    </el-form>
    <div>
      <!-- <p style="background: rgba(250, 220, 220, 1);border-radius: 4px;height: 40px;width: 650px;margin-left:1%;display: inline-block;">
        <span style="width: 85px;color: rgba(201, 28, 28, 1);line-height:40px;background: rgba(255, 189, 189, 1);display: inline-block;text-align:center;border-radius: 4px;">重度等级：</span>

        <span style="color: rgba(201, 28, 28, 1);line-height:40px;margin-left:20px;">总人数：150</span>
        <span style="color: rgba(201, 28, 28, 1);line-height:40px;margin-left:20px;">已访谈：150</span>
        <span style="color: rgba(201, 28, 28, 1);line-height:40px;margin-left:20px;">待访谈：150</span>
        <span style="color: rgba(201, 28, 28, 1);line-height:40px;margin-left:20px;">已跟进：150</span>
        <span style="color: rgba(201, 28, 28, 1);line-height:40px;margin-left:20px;">未跟进：150</span>
      </p>

      <p style="background: rgba(255, 238, 222, 1);border-radius: 4px;height: 40px;width: 650px;margin-left:1%;display: inline-block;">
        <span style="width: 85px;color: rgba(232, 116, 0, 1);line-height:40px;background: rgba(252, 220, 187, 1);display: inline-block;text-align:center;border-radius: 4px;">中度人数：</span>

        <span style="color: rgba(232, 116, 0, 1);line-height:40px;margin-left:20px;">总人数：150</span>
        <span style="color: rgba(232, 116, 0, 1);line-height:40px;margin-left:20px;">已访谈：150</span>
        <span style="color: rgba(232, 116, 0, 1);line-height:40px;margin-left:20px;">待访谈：150</span>
        <span style="color: rgba(232, 116, 0, 1);line-height:40px;margin-left:20px;">已跟进：150</span>
        <span style="color: rgba(232, 116, 0, 1);line-height:40px;margin-left:20px;">未跟进：150</span>
      </p> -->


      <el-table v-loading="loadings" :data="data" style="width: 100%;margin-top:10px;width: 98%;margin-left: 1%;" :default-sort="{ prop: 'date', order: 'descending' }">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学号">
            <template slot-scope="scope">
              <span>{{ scope.row.UserID }}</span>
            </template>
          </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.Sex }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学历">
            <template slot-scope="scope">
              <span>{{ scope.row.Degree }}</span>
            </template>
          </el-table-column>
          <el-table-column label="访谈前风险等级">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.Result }}</span> -->
              <span :class="scope.row.Result == '轻度' ? 'mild' : scope.row.Result == '中度' ? 'moderate' : scope.row.Result == '重度' ? 'severe' : scope.row.Result == '良好' ? 'well' : ''">{{ scope.row.Result }}</span>
            </template>
          </el-table-column>
          <el-table-column label="普测报告" v-if="!this.Global.pdroleid(1073)">
            <template slot-scope="scope">
              <el-button type="text" @click="bg(scope.row)" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="访谈状态">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewStatus }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="腾讯Id号">
            <template slot-scope="scope">
              <span>{{ scope.row.TencentNo }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="访谈日期">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="访谈开始时间">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewTimeBegin }}</span>
            </template>
          </el-table-column>
          <el-table-column label="及时性">
            <template slot-scope="scope">
              <span v-if="scope.row.IsInTime == ''">未填写</span>
              <span v-else-if="scope.row.IsInTime == '0'">超时填写</span>
              <span v-else-if="scope.row.IsInTime == '1'">及时填写</span>
            </template>
          </el-table-column>
          <el-table-column label="访谈结束时间">
            <template slot-scope="scope">
              <span>{{ scope.row.InterviewTimeEnd }}</span>
            </template>
          </el-table-column>
          <el-table-column label="视频会议号">
            <template slot-scope="scope">
              <span>{{ scope.row.TencentNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.ApproveStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200" v-if="!this.Global.pdroleid(1073)">
            <template slot-scope="scope">
              <el-button v-if="scope.row.InterviewStatus =='待访谈'" type="text" @click="open(scope.row)" size="small">
                访谈跟进
              </el-button>
              <el-button v-if="scope.row.InterviewStatus == '待访谈'" type="text" @click="gourl(scope.row)" size="small">
                进入访谈
              </el-button>
              <!-- <el-button v-if="((scope.row.InterviewStatus == '已跟进(准时)' || scope.row.InterviewStatus == '已跟进(迟到)' ||scope.row.InterviewStatus == '未来访') && (scope.row.KeyNo && scope.row.ApproveStatus == '已驳回')) || (scope.row.InterviewStatus == '已跟进(准时)' || scope.row.InterviewStatus == '已跟进(迟到)' ||scope.row.InterviewStatus == '未来访') && !scope.row.KeyNo" type="text" @click="edit(scope.row,1)" size="small">
                修改
              </el-button> -->
              <!-- <el-button v-if="(scope.row.ApproveStatus == '待初审' && !scope.row.KeyNo == '0') || scope.row.InterviewStatus == '未来访'" type="text" @click="edit(scope.row,1)" size="small">
                修改
              </el-button> -->
              <el-button v-if="(scope.row.InterviewStatus == '已跟进(准时)' || scope.row.InterviewStatus == '已跟进(迟到)' ||scope.row.InterviewStatus == '未来访') && (scope.row.KeyNo && scope.row.ApproveStatus !== '已驳回')" type="text" @click="edit(scope.row,2)" size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <!-- currentPage1 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="10" layout="total,prev,pager,next" :total="Counts"></el-pagination>
    <el-dialog close="dialogs" :title="$t('original.languages169')" :before-close="handleClose" :visible.sync="interviewVisible" center>
      <el-form ref="ruleForm" label-width="180px" class="demo-ruleForm">
        <h2 style="margin-left: 15px;">访谈人信息</h2>
        <el-form-item :label="$t('original.languages108')">
          <el-input :disabled="true" v-model="Paperhead.Remark" placeholder="请输入..." show-word-limit></el-input>
        </el-form-item>
        <el-form-item :label="$t('original.languages109')" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1" type="datetime" :placeholder="ts" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </el-form-item>
        <h2 style="margin-left: 15px;">学生信息</h2>
        <ul style="width: 98%;height: 40px;background-color: #befae6;margin-left: 2%;margin-top: 10px;">
          <li style="float: left;width: 25%;line-height:40px;text-indent:20px;">姓名：{{ Paperhead.Name }}</li>
          <li style="float: left;width: 15%;line-height:40px;text-indent:20px;">性别：{{ Paperhead.Sex }}</li>
          <li style="float: left;width: 15%;line-height:40px;text-indent:20px;">年龄：{{ Paperhead.Age }}</li>
          <li style="float: left;width: 45%;line-height:40px;text-indent:20px;">学号：{{ Paperhead.UserID }}</li>
        </ul>
        <h2 style="margin-left: 15px;">访谈前风险等级</h2>
        <span style="margin-left: 15px;font-size: 16px;" :class="Lv == '轻度' ? 'mild' : Lv == '中度' ? 'moderate' : Lv == '重度' ? 'severe' : Lv == '良好' ? 'well' : ''">{{Lv}}</span>
        <h2 style="margin-left: 15px;">访谈状态</h2>
        <el-radio-group v-model="InterviewStatus" style="margin-left: 20px;padding-top: 10px;padding-bottom: 10px;">
          <el-radio label="4">准时</el-radio>
          <el-radio label="5">迟到</el-radio>
          <el-radio label="6">未来访</el-radio>
        </el-radio-group>
        <div v-for="(item, index) in fieldArray" :key="index" :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input type="textarea" maxlength="1000" v-model="item.FormValue" placeholder="请输入..." show-word-limit></el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item :label="item.ShowName" class="ccc" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input maxlength="1000" type="textarea" rows="4" :placeholder="item.desc" v-model="item.FormValue" show-word-limit></el-input>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item :prop="item.ShowName" :label="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-date-picker v-model="item.FormValue" :name="item.ShowName" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <template v-for="child in item.Bobbies" style="margin-top: -20px;">
                <el-radio v-bind:style="{ color: child.FontColor }" v-model="item.FormValue" :label="child.Value">{{ child.Name }}</el-radio>
              </template>
              <br>
              <el-form-item style="display: inline-block;margin-top:20px" v-for="itmes in item.Bobbies" :key="itmes.index">
                <el-input style="height: 80px;" type="textarea" maxlength="1000" v-if="itmes.Display"  v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>
          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-checkbox-group v-model="item.FormValue" style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
        </div>
        <div>
          <p style="padding: 20px;">风险监控员初核意见</p>
          <el-checkbox-group style="margin-left: 20px;" :disabled="true" :max="3" v-model="shenhe.riskMonitorChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
          <el-input style="padding: 20px;width: 90%;" :disabled="true" type="textarea" v-model="shenhe.riskMonitorCheckDetail"></el-input>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="(interviewVisible = false), wppgai()"> {{ $t('original.languages164') }}</el-button> -->
        <el-button v-if="poi" type="primary" @click="submitForm(1)"> 保存(可修改) </el-button>
        <el-button v-if="poi" type="primary" @click="submitForm(0)"> 提交(不可修改) </el-button>
      </span>
    </el-dialog>
    <el-dialog title="测试报告" :visible.sync="dialogVisible" width="50%" center>
      <div style="background:rgba(225, 245, 233, 1);height:40px;line-height:40px;">
        <span style="margin-left: 20px;font-size: 14px;font-weight:400;">{{$t('original.name')}}：{{Paperhead.Name}}</span>
        <span style="margin-left: 20px;font-size: 14px;font-weight:400;">{{$t('original.gender')}}：{{Paperhead.Sex}}</span>
      </div>
      <table style="width:100%;" class="Paperhead">
        <tr style="width:100%;height:40px;line-height:40px;background:rgba(245, 247, 250, 1);">
          <th width="20%">{{$t('original.Test_scale')}}</th>
          <th width="20%">{{$t('original.languages106')}}</th>
          <th width="20%">{{$t('original.languages107')}}</th>
          <th width="20%">均分</th>
        </tr>
        <tr v-for="item in PaperList" :key="item.index" style="height:40px;line-height:40px;text-align:center;">
          <td width="20%">{{item.PaperName}}</td>
          <td width="20%">{{item.PaperScoreR}}</td>
          <td width="20%">{{item.PaperScoreS}}</td>
          <td width="20%">{{item.PaperScoreA}}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shenhe: {
        riskMonitorChecks:[],//风险监控员审核意见
        riskMonitorCheckDetail:'',//风险监控员审核详细意见
        criAdminChecks:[],//危机主管审核意见
        criAdminCheckDetail:'',//危机主管审核详细意见
        centerDirectorChecks:[],//中心主任审核意见
        centerDirectorCheckDetail:'',//中心主任审核详细意见"
      },
      poi:true,
      RoleID:'',
      tys:"新生心理普测访谈记录表",
      Lv: '',
      Paperhead: {
        Name: '',
        Sex: '',
      },
      ts:'',
      PaperList:[],
      dialogVisible:false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      fieldArray:[],
      SaveFlg: 1,
      value1: '',
      InterviewStatus: '4',
      loadings: true,
      interviewVisible: false,
      Counts:0,
      formInline: {
        UserID: '',
        Status: '',
        pageIndex: 1,
      },
      Paperhead: {
        Name: '',
        Sex: '',
        DeptName: '',
        UserID: '',
        Result: '',
        PublishID: '',
        Remark: '',
        Age: '',
      },
      pageSize:10,
      options2: [
        {value:'3',label:'待访谈'},
        {value:'4',label:'已跟进(准时)'},
        {value:'5',label:'已跟进(迟到)'},
        {value:'6',label:'未来访'},
      ],
      data:[],
    };
  },
  methods: {
    bg(res) {
      this.Paperhead.Name = res.RealName;
      this.Paperhead.Sex = res.Sex;
      this.$Http_Post('EmphasisClarification/GetPaperList', {PublishID: res.PublishID, UserID: res.UserID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = true;
          this.PaperList = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    gourl(res) {
      if (res.TencentLink) {
        window.open(res.TencentLink);
      } else {
        alert("未填写链接!");
      }
    },
    submitForm(temporaryFlag) {//提交验证
      this.fieldArray.forEach((item,i) => {
        if(item.RequiredOrNot==1){
          if(item.FormValue || this.InterviewStatus==6){
            this.interviewVisible = false;
            this.$Http_Post('CrisisWarning/AddingConfigForm', {userid: this.Paperhead.UserID,createtime: this.value1,form: this.fieldArray,TableName: this.tys,PublishID: this.Paperhead.PublishID,Modify: false,Remark: this.Paperhead.Remark,InterviewStatus: this.InterviewStatus,temporaryFlag:temporaryFlag}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.Global.request_successful(res.Message);
                this.loading();
              } else {
                this.Global.request_failure(res.Message);
              }
            });
          }else{
            this.$message.error(item.ShowName+"不能为空");
            return false;
          }
        }
      });
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
      .then(_ => {
        done();
      })
      .catch(_ => {
      });
    },
    handleSizeChange(val) {
      this.formInline.pageIndex = val;
      this.loading();
    },
    open(row) {
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Age = row.Age;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.Lv = row.Result;
      this.value1 = row.InterviewDate + " " + row.InterviewTimeBegin;
      this.$Http_Post('/CrisisWarning/GetFormView', {TableName:"新生心理普测访谈记录表",PublishID:row.PublishID,UserID:row.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          if(res.Data.sys_Forms){
            this.interviewVisible = true;
            this.fieldArray = res.Data.sys_Forms;
          }else{
            this.tys = "新生心理普测访谈记录表";
            this.GetPageList();
            this.interviewVisible = true;
            if(row.InterviewStatus == '已跟进(迟到)'){
              this.InterviewStatus = '5'
            }else if(row.InterviewStatus == '未来访'){
              this.InterviewStatus = '6'
            }else{
              this.InterviewStatus = '4'
            }
          }
        }
      });
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.formInline.pageIndex = 1;
      localStorage.setItem('Crisis_major_consult',JSON.stringify(this.formInline))
      this.loading();
    },
    onSubmit2() {
      this.formInline = {UserID:'',Status:''}
      localStorage.setItem('Crisis_major_consult',JSON.stringify(this.formInline));
      this.formInline.pageIndex = 1;
      this.loading();
    },
    loading() {
      this.$Http_Post('EmphasisClarification/GetNeedInterviewList',{UserID:this.formInline.UserID,Status:this.formInline.Status,pageSize:10, pageIndex:this.formInline.pageIndex,ExportFlag:0}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.loadings = false;
          this.Counts = res.Counts;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    derivefun(){
      this.$Http_Post('EmphasisClarification/GetNeedInterviewList',{UserID:this.formInline.UserID,Status:this.formInline.Status,pageSize:10, pageIndex:this.formInline.pageIndex,ExportFlag:1}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    edit(row,type) {
      if(type == 1 && this.Global.pdroleid(1072)){
        this.poi = true;
      }else{
        this.poi = false;
      }
      this.tys = "访谈记录表修改";
      this.interviewVisible = true;
      if(row.InterviewStatus == '已跟进(迟到)'){
        this.InterviewStatus = '5'
      }else if(row.InterviewStatus == '未来访'){
        this.InterviewStatus = '6'
      }else{
        this.InterviewStatus = '4'
      }
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Age = row.Age;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.Lv = row.Result;
      this.value1 = row.InterviewDate + " " + row.InterviewTimeBegin;
      this.$Http_Post('/CrisisWarning/GetFormView', {TableName:"新生心理普测访谈记录表",PublishID:row.PublishID,UserID:row.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.fieldArray = res.Data.sys_Forms;
          this.interviewVisible = true;
          this.$Http_Post('/DistressPrediction/PrefabricatedTableData',{keyNo:row.KeyNo}).then((res) => {
            if (res.Code == 0) {
              this.shenhe = {
                riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
                riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
                criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
                criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
                centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
                centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见"
              }
            }
          });
        }
      });
    },
    GetPageList() {
      this.$Http_Post('CrisisWarning/GetPageList',{TableName:'新生心理普测访谈记录表'}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.FormConfigurations;
          this.SaveFlg = res.Data.SaveFlg;
        }
      });
    }
  },
  mounted() {
    if(localStorage.getItem('Crisis_major_consult')){
      this.formInline = JSON.parse(localStorage.getItem('Crisis_major_consult'));
    }
    this.RoleID = sessionStorage.getItem('RoleID');
    this.loading();
    this.Paperhead.Remark = JSON.parse(localStorage.getItem('userInfo')).UserName;
    this.GetPageList();
  },
  activated(){

  },
  filters: {

  },
};
</script>
<style>
  .Crisis_major_consult{height: 100%;width: 100%;background-color: #fff;}
  tbody td{text-align: center !important;}
  .Crisis_major_consult .colrowspanbottomstyle {border-bottom: 1px solid rgba(225, 226, 227, 1);}
  .Crisis_major_consult .noneborder input {border: 0px;}
  .Crisis_major_consult .bottomborder input {border-bottom: 1px solid rgba(166, 166, 166, 1);}
  .Crisis_major_consult .el-dialog h2 {padding-top: 14px;margin-bottom: 14px;}
  .Crisis_major_consult .el-dialog .标题 {width: 100%;}
  .Crisis_major_consult .el-dialog .el-form>div {margin-left: 14px;}
  .Crisis_major_consult .el-dialog .输入框 input {width: initial;width: 400px;}
  .Crisis_major_consult .el-textarea__inner{height: 80px !important;}
  .Crisis_major_consult .el-dialog .el-input__inner {width: initial;}
  .el-dialog .填空题, .单选题, .时间选择, .文本域{padding: 6px;border: 1px solid rgb(235, 235, 235);margin-top: 4px;}
  .Crisis_major_consult .el-dialog .el-form-item__label{width: initial !important;text-align: right;min-width: 90px;width:132px !important;}
  .Crisis_major_consult .el-dialog  .el-textarea{width: 100%;}
  .Crisis_major_consult .el-dialog .el-form-item__content {margin-left: initial !important;display:flex;align-items: center;}
  .Crisis_major_consult .mild {padding: 0px 15px;background: rgba(29, 154, 255, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px; color: rgba(29, 154, 255, 1);}
  .Crisis_major_consult .moderate {padding: 0px 15px;background: rgba(255, 193, 23, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height:  0px;color: rgba(255, 193, 23, 1);}
  .Crisis_major_consult .severe {padding: 0px 15px;background: rgba(255, 141, 26, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height:  0px;color: rgba(255, 141, 26, 1);}
  .Crisis_major_consult .well {padding: 0px 15px;background: rgba(21, 191, 109, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height: 0px; color: rgba(21, 191, 109, 1);}
  .Crisis_major_consult .urgency {padding: 0px 15px;background: rgba(191, 41, 21, 0.1);font-size: 14px;font-weight: 400;letter-spacing: 0px;line-height:  0px;color: rgb(248, 4, 4);}


</style>
